import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Flashcard.css';

const Flashcard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const flashcardRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const lastShown = localStorage.getItem('flashcardLastShown');
      if (!lastShown || (Date.now() - lastShown > 120000)) {
        // 2 minutes in milliseconds for testing
        setIsVisible(true);
      }
    }, 3000); // Show after 3 seconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (flashcardRef.current && !flashcardRef.current.contains(event.target)) {
        setIsVisible(false);
        localStorage.setItem('flashcardLastShown', Date.now());
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible]);

  return (
    <div ref={flashcardRef} className={`flashcard ${isVisible ? 'open' : 'closed'}`}>
      <h2>Chat with an AI</h2>
      <p>Ask anything and receive human-like responses.</p>
      <Link to="/ai/chatbot">
        Chat Now
      </Link>
    </div>
  );
};

export default Flashcard;
